import { createFileRoute } from "@tanstack/react-router";
import WebMcpSettings from "@/pages/WebMcpSettings";

export const Route = createFileRoute("/_app/webmcp")({
  head: () => ({
    meta: [
      { title: "AI Connect (WebMCP) - Byteline" },
      {
        name: "description",
        content:
          "Connect Byteline stories, daily recaps, weekly briefs and market data to your AI assistant, and see every tool available.",
      },
      { property: "og:title", content: "AI Connect (WebMCP) - Byteline" },
      {
        property: "og:description",
        content: "Use Byteline reporting and market data directly inside your AI assistant.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: () => <WebMcpSettings />,
});
